export default __webpack_public_path__ + "static/media/chat-img.624f92b0.png";